import React, { useEffect, useState } from "react";
import { TextField } from "@mhome/ui";
const TextInput = ({
  valueSpec,
  onChange,
  style = "standard",
  maxHeight = "200px",
}) => {
  const [value, setValue] = useState("");
  const isReadOnly = valueSpec.readOnly;

  useEffect(() => {
    console.debug("valueSpec", valueSpec);
    setValue(valueSpec.value);
    return () => {};
  }, [valueSpec]);

  const handleInputChange = (event) => {
    if (isReadOnly) return;
    const newValue = event.target.value;
    setValue(newValue);
  };

  const handleBlur = () => {
    onChange(value);
  };

  return (
    <div className="flex flex-col w-full h-full items-stretch justify-center overflow-visible pt-px">
      <div
        className={
          style === "compact" ? "absolute inset-0" : "flex-1 relative min-h-0"
        }
      >
        <TextField
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          fullWidth
          multiline
          size="small"
          disabled={isReadOnly}
          className={style === "compact" ? "h-full" : ""}
          style={{
            ...(style === "compact" && {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              height: "100%",
            }),
            ...(style === "standard" && {
              minHeight: "40px",
              maxHeight: maxHeight,
            }),
          }}
          InputProps={{
            style: {
              ...(style === "compact" && {
                height: "100%",
                padding: "8px",
              }),
              ...(style === "standard" && {
                minHeight: "40px",
                maxHeight: maxHeight,
                padding: "4px",
              }),
              cursor: isReadOnly ? "default" : "text",
              backgroundColor: "transparent",
            },
            readOnly: isReadOnly,
          }}
        />
      </div>
    </div>
  );
};

export default TextInput;
